/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import { notificationConfig } from '@/slw/entities/notification/notification.const';
import { Notification } from '@/slw/entities/notification/notification.type';
import { fToNow } from '@/slw/shared/lib/date';

interface NotificationItemProps {
  notification: Notification;
  onMarkReadItem: (item: Notification) => void;
}

export const NotificationItem = ({ notification, onMarkReadItem }: NotificationItemProps) => {
  const config = notificationConfig[notification.type];
  const Icon = config.icon;
  const colorClass = config.color;

  const handleClick = async () => {
    onMarkReadItem(notification);
  };

  return (
    <div
      onClick={handleClick}
      className={`p-6 hover:bg-gray-50 transition-colors duration-200 cursor-pointer ${
        !notification.isRead ? 'bg-blue-50' : ''
      }`}
    >
      <div className='flex items-start space-x-3'>
        {/* Icon */}
        <div className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center ${colorClass}`}>
          <Icon className='w-4 h-4' />
        </div>

        {/* Content */}
        <div className='flex-1 min-w-0'>
          <p className={`text-sm font-semibold ${!notification.isRead ? ' text-gray-900' : 'text-gray-800'}`}>
            {notification.title}
          </p>

          {notification.title && <p className='text-xs text-gray-600 mt-1 line-clamp-4'>{notification.message}</p>}
          <p className='text-xs text-blue-500 mt-1'>{fToNow(notification.createdAt || '')}</p>
        </div>

        {/* Unread indicator */}
        {!notification.isRead && <div className='flex-shrink-0 w-2 h-2 bg-blue-500 rounded-full'></div>}
      </div>
    </div>
  );
};
